@if (visible()) {
  <div class="cookie-banner" role="dialog" aria-live="polite" aria-label="Aviso de cookies">
    <div class="cookie-banner__content">
      <p class="cookie-banner__text">
        {{ 'shared.cookies.banner.message' | translate }}
        {{ 'shared.cookies.banner.moreInfo' | translate }}
        <a class="cookie-banner__link" routerLink="/policies/cookies">{{ 'shared.cookies.banner.policyLink' | translate }}</a>
        .
      </p>

      <div class="cookie-banner__actions">
        <button class="cookie-banner__btn cookie-banner__btn--primary" (click)="acceptAll()">
          {{ 'shared.cookies.actions.acceptAll' | translate }}
        </button>
        <button class="cookie-banner__btn" (click)="rejectAll()">{{ 'shared.cookies.actions.rejectAll' | translate }}</button>
        <button class="cookie-banner__btn cookie-banner__btn--ghost" type="button" (click)="configure()">
          {{ 'shared.cookies.actions.save' | translate }}
        </button>
      </div>
    </div>
  </div>
}
